import clsx from 'clsx';
import { Fragment, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useAnalytics } from 'use-analytics';
import Dropdown from '../../../Dropdown';

const CustomHeaderLinks = ({ travelAgencySettings }) => {
  const { track } = useAnalytics();
  const { isLoggedIn } = useSelector((store) => store.user);

  const handleClickHeaderFlightLink = useCallback((linkTitle) => {
    track('clickedHeaderLink', { title: linkTitle });
  }, [track]);

  const displayHeaderLinkElement = useMemo(() => {
    const headerLinks = travelAgencySettings?.headerLinks;
    if (!headerLinks?.length) return <></>;

    const filteredLinks = headerLinks
      .filter((headerLink) => headerLink && !(headerLink.doHideForCFP && !isLoggedIn));
    if (!filteredLinks.length) return <></>;

    return filteredLinks.map((headerLink) => (
      <Fragment key={headerLink.title || headerLink.link}>
        {headerLink.dropdownContent ? (
          <Dropdown className="cursor-pointer self-center">
            <Dropdown.Toggle>
              <a className="inline-block align-middle text-sm md:text-lg self-center" tabIndex="-1" role="button" onKeyDown={() => {}} onClick={() => handleClickHeaderFlightLink(headerLink.title)}>
                <span>{headerLink.title}</span>
              </a>
            </Dropdown.Toggle>
            <Dropdown.Menu widthClass="w-56 md:w-96" shadowClass="shadow-2xl" alignClass="left-0 md:left-auto right-auto md:right-0">
              <Dropdown.Item withGridLayout={false}>
                <div dangerouslySetInnerHTML={{ __html: headerLink.dropdownContent }} className="whitespace-normal break-all md:break-normal" />
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        ) : (
          <a className={clsx('inline-block align-middle text-sm md:text-lg self-end md:self-center')} onClick={() => handleClickHeaderFlightLink(headerLink.title)} target="_blank" rel="noreferrer" href={headerLink.link} key={headerLink.link}>
            <span>{headerLink.title}</span>
          </a>
        )}
      </Fragment>
    ));
  }, [handleClickHeaderFlightLink, travelAgencySettings, isLoggedIn]);

  return displayHeaderLinkElement;
};

export default CustomHeaderLinks;
